import classnames from 'classnames';
import React, { useEffect } from 'react';
import { usePrefersReducedMotion } from '@jokerdad/hooks';
import { useMainContext } from '@jokerdad/providers';
import styles from './Searchbar.module.css';
import { enterAnimation, enterWithoutAnimation } from './utils';

var Searchbar = function Searchbar(_ref) {
  var onSubmit = _ref.onSubmit,
      onChange = _ref.onChange;
  var formClasses = classnames('flex justify-center items-center flex-col w-screen h-full relative z-10 bg-secondary opacity-0', 'js-anime-search-form');
  var effectClasses = classnames('w-[7rem] h-[7rem] absolute top-0 right-0 z-0 mt-8 mr-8 bg-secondary rounded-full pointer-events-none', 'js-anime-wave-effect');
  var isReducedMotionPreferred = usePrefersReducedMotion();

  var _useMainContext = useMainContext(),
      visitingViaUrl = _useMainContext[0].visitingViaUrl;

  useEffect(function () {
    if (isReducedMotionPreferred || visitingViaUrl) {
      return enterWithoutAnimation();
    }

    enterAnimation();
  }, [isReducedMotionPreferred, visitingViaUrl]);
  return /*#__PURE__*/React.createElement("div", {
    className: "h-screen overflow-hidden relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: effectClasses
  }), /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit,
    className: formClasses
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    onChange: onChange,
    placeholder: "Search...",
    className: classnames(styles.input, 'w-9/10 max-w-screen-md border-b border-white border-solid bg-transparent text-white text-3-6 leading-none opacity-60 transition-opacity duration-200 ease-in-out')
  })));
};

export default Searchbar;